// extracted by mini-css-extract-plugin
export var assigneeBadge = "_n8-0";
export var assigneeDetails = "_n8-1";
export var assigneeInfo = "_n8-2";
export var dropdownContainer = "_n8-4";
export var dropdownImage = "_n8-5";
export var editAssigneeInfo = "_n8-3";
export var editAssigneeModalContainer = "_n8-6";
export var hidden = "_n8-8";
export var input = "_n8-7";